import useAddProfileByService from '../logic/useAddProfileByService'
import { Row, Tooltip } from 'antd'
import { Actions, Button } from 'components/atoms'
import { ActionType } from 'components/atoms/actions'
import { ActionsEditDelete } from 'constants/actionsType'
import { IPatient } from 'pages/patientReceive/interfaces'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
  onAction: (action: ActionType, patient: IPatient) => void
  patient: IPatient
}
const ActionPatient = (props: IProps) => {
  const { onAction, patient } = props
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const isProfileInClinic = !!patient?.user_code

  const reload = () => {
    onAction(ActionType.Reload, patient)
  }
  const { handleRequestAddProfile } = useAddProfileByService(reload)
  const handleOnAction = async () => {
    if (isProfileInClinic) {
      onAction(ActionType.Add, patient)
      return
    }
    setLoading(true)
    await handleRequestAddProfile(patient)
    setLoading(false)
  }

  return (
    <Row gutter={16}>
      <Tooltip
        title={!isProfileInClinic ? t('tooltip-add-profile') : undefined}>
        <Button
          loading={loading}
          onClick={handleOnAction}
          icon={<img src="/images/ic-add.svg" alt="" />}
          style={{ height: 32, marginRight: 16, marginLeft: 16 }}
          color="green">
          {t(isProfileInClinic ? 'booking' : 'add-profile')}
        </Button>
      </Tooltip>
      {isProfileInClinic && (
        <Actions
          actions={ActionsEditDelete}
          justifyContent="center"
          onClick={(actionType) => onAction(actionType, patient)}
        />
      )}
    </Row>
  )
}

export default ActionPatient
